export const shortCodesEmpty = [];
export const emailDomainsEmpty = [];
export const callerIdsEmpty = [];

const toNonEmptyString = (value) => {
  if (value == null) {
    return "";
  }
  return String(value).trim();
};

const asArray = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (value == null || value === "") {
    return [];
  }
  return [value];
};

export const getShortCodes = (smsConfig) => {
  if (!smsConfig || typeof smsConfig !== "object") {
    return shortCodesEmpty;
  }
  const {
    sinchShortCodes = [],
    xmlShortCodes = [],
    jasminShortCodes = [],
  } = smsConfig;
  return [
    ...asArray(sinchShortCodes),
    ...asArray(xmlShortCodes),
    ...asArray(jasminShortCodes),
  ]
    .map(toNonEmptyString)
    .filter(Boolean)
    .map(Number)
    .filter((code) => Number.isFinite(code))
    .sort((a, b) => a - b);
};

export const getEmailDomains = (emailConfig) => {
  if (!emailConfig || typeof emailConfig !== "object") {
    return emailDomainsEmpty;
  }
  const { domainAddress } = emailConfig;
  if (!domainAddress) {
    return emailDomainsEmpty;
  }
  const rawDomains = Array.isArray(domainAddress)
    ? domainAddress
    : String(domainAddress).split(",");
  const domains = rawDomains.map(toNonEmptyString).filter(Boolean);
  return domains.length ? domains : emailDomainsEmpty;
};

export const getCallerIds = (vendorConfig, voiceConfig) => {
  if (!vendorConfig || !voiceConfig) {
    return callerIdsEmpty;
  }
  const { callerId } = vendorConfig;
  const rawCallerIds = Array.isArray(callerId)
    ? callerId
    : callerId != null && callerId !== ""
    ? [callerId]
    : [];
  const callerIds = rawCallerIds.map(toNonEmptyString).filter(Boolean);
  return callerIds.length ? callerIds : callerIdsEmpty;
};

export const SUPPRESSION_TYPE_ENUM = {
  EMAIL: "email",
  VOICE: "voice",
  SMS: "sms",
};
export const suppressionTypeMapMsg = {
  [SUPPRESSION_TYPE_ENUM.EMAIL]: "Suppression Email",
  [SUPPRESSION_TYPE_ENUM.VOICE]: "Suppression Voice",
  [SUPPRESSION_TYPE_ENUM.SMS]: "Suppression Number",
};
export const defaultChannelType = SUPPRESSION_TYPE_ENUM.SMS;

export const normalizeSuppressionType = (type) => {
  if (!type || typeof type !== "string") {
    return null;
  }
  const typeNormalized = type.trim().toLowerCase();
  return Object.values(SUPPRESSION_TYPE_ENUM).includes(typeNormalized)
    ? typeNormalized
    : null;
};

const missingConfigMessages = {
  [SUPPRESSION_TYPE_ENUM.EMAIL]:
    "Email config or domain address(es) are missing!",
  [SUPPRESSION_TYPE_ENUM.SMS]: "SMS config or short code(s) are missing!",
  [SUPPRESSION_TYPE_ENUM.VOICE]: "Voice config or caller id(s) are missing!",
};

export const getMissingConfigMessage = (
  type,
  { shortCodes = [], domainAddresses = [], callerIds = [] } = {}
) => {
  switch (type) {
    case SUPPRESSION_TYPE_ENUM.EMAIL:
      return domainAddresses.length ? null : missingConfigMessages[type];
    case SUPPRESSION_TYPE_ENUM.SMS:
      return shortCodes.length ? null : missingConfigMessages[type];
    case SUPPRESSION_TYPE_ENUM.VOICE:
      return callerIds.length ? null : missingConfigMessages[type];
    default:
      return null;
  }
};

export const onInputTabChange = (history) => (_, activeTab) => {
  if (activeTab) {
    history.push(`/suppression?type=${activeTab}`);
  }
};
